const getCountryDetailNavItems = (countryId) => {
    const basePath = `/discovery/countries/${countryId}`;

    return [
        { to: basePath, eventKey: 'generalInfo', label: 'General info', end: true },
        { to: `${basePath}/cities`, eventKey: 'cities', label: 'Cities' },
        {
            to: `${basePath}/jobs`,
            eventKey: 'companies',
            label: 'Companies & Jobs',
            alsoActive: [`${basePath}/companies`],
        },
        { to: `${basePath}/visa-stay`, eventKey: 'visaStay', label: 'Visa & Stay' },
        { to: `${basePath}/work-tax`, eventKey: 'workTax', label: 'Work & Tax' },
        { to: `${basePath}/financials`, eventKey: 'financials', label: 'Financials & Banks' },
        { to: `${basePath}/housing`, eventKey: 'housing', label: 'Housing & Life' },
        { to: `${basePath}/social`, eventKey: 'social', label: 'Social' },
        { to: `${basePath}/industries`, eventKey: 'industries', label: 'Industries & Carrier' },
    ];
};

export default getCountryDetailNavItems;
